import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  form: {
    width: "100%",
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },

  enterGuest: {
    margin: theme.spacing(3, 0, 2),
    marginTop: "6px"
  }
}));
